/**
 * Plan icon — stylized architectural plan.
 * Represents the PlanView mode. Used in Mobile navigation.
 * Uses `currentColor` for stroke.
 */
export function Plan({
	className,
	width = '1em',
	height = '1em',
	...rest
}) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 15 15"
			stroke="none"
			fill="currentColor"
			strokeWidth="0"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			className={className}
			{...rest}
		>
      <path 
				d="M0 0H4.65139L7.77735 2.08397L7.22265 2.91603L4.34861 1H1V14H6V8H4V7H9V8H7V14H14V8H12V7H14V1H10V0H15V15H0V0Z"
			/>
  </svg>
  );
}